import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search',
})
export class SearchPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    try {
      if (!value) return null;
      if (!args) return value;
      return value.filter((data) => {
        return JSON.stringify(data).toLowerCase().includes(args.toLowerCase());
      });
    } catch (error) {
      // console.log(error)
    }
  }
}

@Pipe({
  name: 'numberTo',
})
export class NumberToPipe implements PipeTransform {
  transform(value: number): string {
    if (value < 1000) {
      return value.toString();
    } else if (value >= 1000 && value < 100000) {
      return (value / 1000).toFixed(0) + 'k';
    } else if (value >= 100000 && value < 10000000) {
      return (value / 100000).toFixed(0) + ' lac';
    } else {
      return (value / 10000000).toFixed(0) + ' cr.';
    }
  }
}

@Pipe({
  name: 'secondsToMinutesSeconds',
})
export class SecondsToMinutesSecondsPipe implements PipeTransform {
  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    const seconds: number = Math.floor(value % 60);
    return `${minutes} m, ${seconds} s`;
  }
}

@Pipe({
  name: 'searchSectionTitle',
})
export class searchSectionTitlePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return value.filter((data) => {
      if (!value) return null;
      if (!args) return value;
      return JSON.stringify(
        data?.lesson_plan?.global_pacing_plan
          ? data?.lesson_plan?.global_pacing_plan?.section_title
          : data?.lesson_plan?.teacher_custom_pacing_plans?.section_title
          ? data?.lesson_plan?.teacher_custom_pacing_plans?.section_title
          : data?.lesson_plan?.custom_global_pacing_plan?.section_title
      )
        .toLowerCase()
        .includes(args.toLowerCase());
    });
  }
}
